import { deleteCookie, extractCookie, shouldSetSecureCookie } from 'lib/web/cookieUtils'

/**
 * Client-only cookie naming the pricing the page was last reloaded for, so a pricing change
 * reloads at most once. A cookie, not sessionStorage: where sessionStorage is blocked,
 * `isomorphicSessionStorage` falls back to memory, which a reload wipes, so the guard would not
 * survive the reload it guards and the page could reload forever.
 */
export const CHANNEL_MARKUP_V2_REFRESH_COOKIE_NAME = 'lecmPriceRefresh'

export function getChannelMarkupV2RefreshCookie(): string | undefined {
  return extractCookie(document.cookie, CHANNEL_MARKUP_V2_REFRESH_COOKIE_NAME)
}

export function setChannelMarkupV2RefreshCookie(refreshKey: string): void {
  // No Max-Age: a browser-session cookie. It only has to outlive the reload it guards.
  document.cookie = `${CHANNEL_MARKUP_V2_REFRESH_COOKIE_NAME}=${encodeURIComponent(refreshKey)}; Path=/; SameSite=Lax${shouldSetSecureCookie() ? '; Secure' : ''}`
}

export function clearChannelMarkupV2RefreshCookie(): void {
  deleteCookie(CHANNEL_MARKUP_V2_REFRESH_COOKIE_NAME, '/')
}
